<p-dialog [(visible)]="showApprovalStatusDialog" header="Payment Status" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40"
          dismissableMask="true" appendTo="body" [contentStyle]="{'overflow-y':'auto'}">
  <div *ngIf="orgPaymentTransaction">
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Payment Amount</label>
      </div>
      <div *ngIf="!_request.txnHistory" class="p-col-12 p-md-8 p-lg-8">
        {{orgPaymentTransaction.paymentAmount | currency: Format.Currency}}
      </div>
      <div *ngIf="_request.txnHistory" class="p-col-12 p-md-8 p-lg-8">
        {{orgPaymentTransaction.txnTotalAmount | currency: Format.Currency}}
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Payment Status</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        {{orgPaymentTransaction.paymentStatus}}
        <button *ngIf="!_request.txnHistory && orgPaymentTransaction.paymentType == PaymentType.ACH &&
        orgPaymentTransaction.transactionId && !(orgPaymentTransaction.paymentStatus ==
        PaymentStatusType.Processed)" pButton
                type="button"
                class="add wrapper action-secondary"
                icon="fa fa-refresh"
                (click)="refreshPaymentStatus(request,orgPaymentTransaction)"
                iconPos="left"></button>
        <button *ngIf="orgPaymentTransaction.paymentStatus == PaymentStatusType.Error && orgPaymentTransaction.transactionId && orgPaymentTransaction.paymentType == PaymentType.ACH" pButton
                type="button"
                class="icon-negative"
                icon="fa fa-exclamation-triangle"
                pTooltip="View Failure Reason" (click)="getPaymentFailureReason($event,request,orgPaymentTransaction,failureReason)"></button>
        <button *ngIf="orgPaymentTransaction.paymentStatus == PaymentStatusType.Error && orgPaymentTransaction.transactionId && orgPaymentTransaction.paymentType == PaymentType.ACH" pButton
                type="button"
                class="icon-action"
                icon="fa fa-dollar"
                pTooltip="Retry Payment" (click)="retryPaymentForFailureTransaction(orgPaymentTransaction)"></button>

        <button *ngIf="displayCancelOption && orgPaymentTransaction.transactionId && orgPaymentTransaction.paymentType == PaymentType.ACH"
                pButton
                type="button" class="icon-negative" icon="fa fa-stop-circle" pTooltip="Cancel Payment"
                tooltipPosition="top" (click)="cancelPayment(orgPaymentTransaction)"
                [disabled]="!orgPaymentTransaction.canCancelTransaction"></button>
        <button *ngIf="displayCancelOption && !orgPaymentTransaction.canCancelTransaction" pButton class="icon-action" icon="fa fa-info-circle"
                pTooltip="{{cancelToolTipInfo}}"
                tooltipPosition="top"></button>


        <p-overlayPanel class="pay-error-panel" #failureReason [showCloseIcon]="true" [dismissable]="true">
          <div *ngIf="achError && achError.message">{{achError.message}} </div>
        </p-overlayPanel>
      </div>
    </div>

    <div *ngIf="orgPaymentTransaction && !orgPaymentTransaction?.transactionId && orgPaymentTransaction.errorMessage" class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Failure Reason</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        {{orgPaymentTransaction.errorMessage}}
      </div>
    </div>

    <div *ngIf="achError && achError.message" class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Failure Reason</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        {{achError.message}}
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Payment Type</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        {{orgPaymentTransaction.paymentType}}
      </div>
    </div>

    <div *ngIf="orgPaymentTransaction.paymentType != PaymentType.ManualCheck && orgPaymentTransaction.paymentType != PaymentType.OtherElectronic">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Transaction Id</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.transactionId}}
        </div>
      </div>
    </div>

    <div *ngIf="orgPaymentTransaction.paymentType == PaymentType.Check || orgPaymentTransaction.paymentType == PaymentType.ManualCheck" id="checkTxnStatus">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Check Number</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.checkOrReferenceNumber}}
          <button *ngIf="orgPaymentTransaction.paymentType == PaymentType.Check && orgPaymentTransaction?.paymentFileId" pButton type="button"
                  class="icon-action" icon="fa fa-download"
                  pTooltip="Download Check or ACH detail"
                  tooltipPosition="top" (click)="onClickDownloadCheck(orgPaymentTransaction.paymentFileId)">
          </button>
        </div>
      </div>
    </div>


    <div *ngIf="orgPaymentTransaction.paymentType == PaymentType.OtherElectronic" id="otherTxnStatus">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Reference Number</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.checkOrReferenceNumber}}
        </div>
      </div>
    </div>

    <div *ngIf="orgPaymentTransaction.paymentType == PaymentType.ACH" id="achTxnStatus">

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Sender Bank Name</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.senderBankName}}
        </div>
      </div>


      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Sender Routing Number</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.senderRoutingNumber}}
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Sender Account Number</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.senderAccountNumber | accountNumberMask}}
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Receiver Bank Name</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.receiverBankName}}
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Receiver Routing Number</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.receiverRoutingNumber}}
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Receiver Account Number</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgPaymentTransaction.receiverAccountNumber | accountNumberMask}}
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="!orgPaymentTransaction">
    Payment status of your transaction is not available yet. Please try again later.
  </div>

  <div *ngIf="orgPaymentTransaction && _request.txnHistory && _request.paymentTransaction == PaymentTxnType.VoucherRegister">
    <app-data-table [columns]="voucherRegisterTableHeaders" [value]="voucherRegisters"
                    [footerTemplate]="footerTemplate"
                    [disableSearch]="true">
      <ng-template #footerTemplate>
        <tr *ngIf="voucherRegisters.length >0">
          <td style="text-align:right;" colspan="4">Total</td>
          <td *ngIf="!_request.txnHistory" colspan="1">
            {{orgPaymentTransaction.paymentAmount | currency: Format.Currency}}
          </td>
          <td *ngIf="_request.txnHistory" colspan="1">
            {{orgPaymentTransaction.txnTotalAmount | currency: Format.Currency}}
          </td>
        </tr>
      </ng-template>
    </app-data-table>
  </div>

  <p-footer>
    <div style="margin:10px;text-align: right;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="close()"></button>
    </div>
  </p-footer>
</p-dialog>
<p-confirmDialog key="cancelConfirmation"></p-confirmDialog>


